"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KB_CHAR_LIMIT = void 0;
/**
 * 平台知识库聚合注入 AI prompt 的字符上限。
 *
 * 客服订阅的多个平台万云3知识库(knowledge-hub)的 markdown 全文聚合拼 prompt 时，
 * 按此上限截断（见 BE CsKnowledgeService.getSubscribedKbItems）。豆包 pro-32k 模型
 * 扣除多轮历史 + 输出 + system 框架后，留给「全量拼 KB」的安全容量约为天花板的 1/3。
 *
 * 注：旧的本地知识库（knowledge_bases / knowledge_items 增删改 + 容量校验）已彻底下线，
 * 相关 schema / 容量错误码 / 工具函数随之移除，此处仅保留运行时聚合仍需的字符上限常量。
 */
exports.KB_CHAR_LIMIT = 24_000;
//# sourceMappingURL=knowledge-base.js.map